import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {categoriesList2FilterParams} from '../../misc/categoriesList2FilterParams';

/**
 * Returns the recommended participants filter for a given event.
 *
 * @param {number} eventId - The ID of the event.
 * @return {object} The recommended participants filter for the event.
 */
export function useRecommendedParticipantsFilter(eventId) {
    const selectRecommendedFilter = useMemo(() => state => state.events[eventId]?.participants.recommendedFilter, [eventId]),
        recommendedFilter = useSelector(selectRecommendedFilter),
        filter = useMemo(() => {
            return recommendedFilter ? categoriesList2FilterParams(recommendedFilter) : null;
        }, [recommendedFilter]);

    return filter;
}
